import { createStore } from 'framework7';
import { http } from '../api/config.js';

const buyoutDeposit = createStore({
  state: {
    item: {},
    list: [],
  },
  actions: {
//Mutations
    set_item({ state }, item) {
      state.item = item;
    },
    set_list({ state }, list) {
      state.list = list;
    },
//End mutations

    async getData({ dispatch }, buyoutDepositId){
      let response = [];
      let result = {};

      result = await http.get(`buyout/deposit/single/${buyoutDepositId}`);
      if (result.status === 200){
        response = result.data;
        return response;
      }
      else{
        return result;
      }
    },

    async getListActive({ dispatch }){
      let response = [];
      let result = {};

      result = await http.get(`buyout/list/active`);
      if (result.status === 200){
        response = result.data;
        dispatch('set_list', response);
        return response;
      }
      else{
        return result;
      }
    },

    async getFullList({ dispatch }){
      let response = [];
      let result = {};

      result = await http.get(`buyout/list/all`);
      if (result.status === 200){
        response = result.data;
        return response;
      }
      else{
        return result;
      }
    },

    async create({ dispatch }, data){
      let response = [];
      let result = {};

      result = await http.post(`buyout/deposit/create`, data, { headers: {'content-type': 'application/x-www-form-urlencoded'} });
      if (result.status === 201){
        response = result.data;
        return response;
      }
      else{
        return result;
      }
    },

    async modifyData({ dispatch }, data){
      let response = [];
      let result = {};

      result = await http.post(`buyout/deposit/modify`, data, { headers: {'content-type': 'application/x-www-form-urlencoded'} });
      if (result.status === 200){
        response = result.data;
        return response;
      }
      else{
        return result;
      }
    },
  },
  getters: {
    Item({ state }) {
      return state.item;
    },
    List({ state }) {
      return state.list;
    },
  },
});

export default buyoutDeposit;
